import { Component, OnInit, Input } from '@angular/core';
import { TranslationService } from '../../shared/index';
import { FormElementFile } from '../shared/model/form-element-file.model';

@Component({
  selector: 'wl-form-builder-upload-file-display-element',
  templateUrl: 'form-builder-upload-file-display-element.component.html',
    standalone: false
})
export class FormBuilderFileUploadDisplayElementComponent {
  private _translationService: TranslationService;

  @Input('fileUploadSettings') fileUploadSettings: FormElementFile;

  public constructor(translationService: TranslationService) {
    this._translationService = translationService;
  }
}
